import { GetServerSideProps } from 'next'
import { serverSideTranslations } from '../src/utils/convergence'
import React from 'react'
import { withPublic } from '../src/component'
import { getLayout } from '../src/layouts/MainLayout'
import { CheckoutPage } from '../src/model'
import { PasswordPage as Password } from '../src/page'
import { getTheme } from '../src/utils/server/convergence'
import { getFlowProps } from '../src/utils/server/flowProps'

const I18N_NAMESPACE = ['common', 'terminalError', 'password', 'login', 'verify']

const PasswordPage: CheckoutPage = (props) => <Password {...props} />

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { theme } = await getTheme(context)
  const flowProps = getFlowProps(context)
  return {
    props: {
      theme,
      ...(await serverSideTranslations(context.locale as string, I18N_NAMESPACE)),
      ...flowProps,
    },
  }
}

const PasswordPagePublic: CheckoutPage = withPublic(PasswordPage)
PasswordPagePublic.getLayout = getLayout()

export default PasswordPagePublic
